// Modo manutenção da Área do Cliente.
// true  -> a tela de login aparece normal, com um aviso discreto embaixo, mas
//          ninguém entra: o "Entrar" não chama a API, a sessão de quem já estava
//          logado não é restaurada e o link de acesso (token-login) é recusado.
// false -> sistema normal.
// Para reabrir: trocar para false e subir (deploy automático na Vercel).
export const MANUTENCAO_ATIVA = true;

export const MANUTENCAO_MENSAGEM =
  "Sistema em manutenção para implementação de melhorias. O acesso está temporariamente suspenso — voltamos em instantes.";
